import { useCallback, useMemo, useState } from 'react';

import { Section } from '../types/PolicyCoverage';

export function usePolicyCoverageNavigation(sections: Section[]) {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const effectiveSelectedId = selectedId ?? sections[0]?.identifier ?? null;

  const indexById = useMemo(() => {
    const map = new Map<string, number>();
    sections.forEach((s, i) => map.set(s.identifier, i));
    return map;
  }, [sections]);

  const getNextId = useCallback(
    (fromIdentifier: string): string | null => {
      const index = indexById.get(fromIdentifier);
      if (index == null) return null;
      return sections[index + 1]?.identifier ?? null;
    },
    [indexById, sections],
  );

  const select = useCallback((identifier: string) => {
    setSelectedId(identifier);
  }, []);

  const advanceFrom = useCallback(
    (fromIdentifier: string) => {
      const next = getNextId(fromIdentifier);
      if (next) setSelectedId(next);
    },
    [getNextId],
  );

  return { selectedId: effectiveSelectedId, select, advanceFrom, getNextId };
}
